import React from 'react';
import PropTypes from 'prop-types';
import { clone, reverse } from 'lodash';
var SvgContextMixin = require('./svgContextMixin');

/**
 * Book band axis (vertical)
 */
var SvgChartBookBandAxis = React.createClass({
  mixins: [SvgContextMixin],

  statics: {
    id: "BookBandYAxis",
    bookBandGridId: "BookBandSingleGrid",
    activeGridStroke: "#3b66b1",
    textHeightRate: 0.6,

    getAxisLength: function getAxisLength(bookBands) {
      if (!!bookBands) {
        return bookBands.length;
      }
      ;

      return 1;
    },
  },

  propTypes: {
    labelWidth: PropTypes.number,
    activeBookBandList: PropTypes.array,
    displayLabel: PropTypes.string,
    bookBands: PropTypes.array,
    displayBookBandLabel: PropTypes.bool
  },

  getDefaultProps: function() {
    return {
      displayBookBandLabel: true
    };
  },

  render(){
    return (
      <g id={SvgChartBookBandAxis.id}>
        {this._getLabel()}
        {this._getGrid()}
      </g>
    );
  },

  _getLabel(){
    var {displayLabel, box, labelWidth, displayBookBandLabel} = this.props;
    if (!displayLabel) return null;

    var x = this.context.relativeX(box[0]) + this.context.width / 100,
      y = this.context.relativeY(box[1] + box[3] / 2),
      fontSize = this.context.getFontSize(this.context.relativeX(displayBookBandLabel ? (labelWidth/5) : labelWidth) * SvgChartBookBandAxis.textHeightRate),
      transform = "rotate(-90 " + x + "," + y + ")";

    return <text x={x} y={y}
                 fontFamily={this.context.font}
                 fontSize={fontSize}
                 transform={transform}
                 dominantBaseline="hanging"
                 textAnchor="middle"
    >
      {displayLabel}
    </text>
  },

  _getGrid(){
    var {box, labelWidth, bookBands, displayBookBandLabel} = this.props;

    var gridCount = bookBands.length,
      gridLineHeight = this.context.relativeY(box[3]) / gridCount,
      gridLineWidth = this.context.relativeX(box[2]) - this.context.relativeX(labelWidth);

    var y = this.context.relativeY(box[1]),
      x = this.context.relativeX(box[0]) + this.context.relativeX(labelWidth);

    var fontSize = this.context.getFontSize(gridLineHeight / 3);
    var labelPadding = this.context.relativeX(labelWidth) * 0.05;
    var grid = [];

    var orderedBookBands = clone(bookBands);
    reverse(orderedBookBands);

    var strokeY = 0, strokeHeight = 0;
    for (var i = 0; i < gridCount; i++) {

      var y0 = y + gridLineHeight * i,
        labelY = y0 + gridLineHeight / 2;

      var bookBandItem = orderedBookBands[i];

      var isStrokeItem = this._checkIsStrokeItem(bookBandItem);
      if (isStrokeItem) {
        strokeHeight = strokeHeight + gridLineHeight;
        if (strokeY == 0) {
          strokeY = y0;
        }
      }
      else {
        if (strokeY > 0) {
          grid = grid.concat(this._getStrokeGrid(x, strokeY, gridLineWidth, strokeHeight, i - 1));
          strokeY = 0;
          strokeHeight = 0;
        }
      }
      grid = grid.concat(this.getLevelGrid(x, y0, gridLineWidth, gridLineHeight, i, bookBandItem));
      if (displayBookBandLabel) {
        grid = grid.concat(this.getLevelTitle(x - labelPadding, labelY, fontSize, i, orderedBookBands[i].title));
      }
    }

    if (strokeY > 0) {
      grid = grid.concat(this._getStrokeGrid(x, strokeY, gridLineWidth, strokeHeight, 0));
    }

    return grid;
  },

  _checkIsStrokeItem(bookBandItem) {
    var {activeBookBandList} = this.props;

    if (!activeBookBandList || activeBookBandList.length == 0 || !bookBandItem) {
      return false;
    }

    var activeBookBand = activeBookBandList.filter((item) => bookBandItem.id == item.id);
    var isStrokeItem = (!!activeBookBand && activeBookBand.length > 0);

    return isStrokeItem;
  },

  getLevelGrid(x, y, width, height, key, bookBandItem){
    var lineHeight = height;
    return [
      <rect x={x} y={y} key={"hight-"+key}
            width={width}
            height={lineHeight}
            fill={bookBandItem.hexColor}
            stroke="none" />
    ];
  },

  getLevelTitle(x, y, fontSize, key, bookBandTitle) {
    return [
      <text x={x} y={y} key={"bb-title-"+key}
                 fontFamily={this.context.font}
                 fontSize={fontSize}
                 dominantBaseline="hanging"
                 textAnchor="end"
    >
    {bookBandTitle}
    </text>
    ];
  },

  _getStrokeGrid(x, y, width, height, key){
    return [
      <rect x={x+1} y={y+1} key={'active-year-'+key}
            width={width-2}
            height={height-2}
            fill="none"
            stroke={SvgChartBookBandAxis.activeGridStroke}
            strokeWidth="2"/>
    ];
  },
});


module.exports = SvgChartBookBandAxis;
